/* eslint-disable */
import {
    LoginWithPasswordRequestModel, 
    LoginWithPasswordResponseModel,
    CompaniesListRequestModel,
    CompaniesListResponseModel,
    ChangeCompanyStatusResponseModel,
    DeleteCompaniesListRequestModel,
    BaseResponseModel,
    ChangeCompanyStatusRequestModel,
    CreateCompanyRequestModel,
    CreateCompanyResponseModel,
    ChangeCompanyNameRequestModel,
    ChangeCompanyNameResponseModel,
    GetCompanyResponseModel,
    CompanyEmployeesListResponseModel,
    ChangeEmployeeStatusResponseModel,
    DeleteEmployeesListRequestModel,
    CreateEmployeeRequestModel,
    CreateEmployeeResponseModel,
    EditEmployeeRequestModel,
    EditEmployeeResponseModel,
    GetCompanyEmployeeResponseModel,
    ChangeEmployeeStatusRequestModel,
    GetCompanyWithUsersResponseModel,
    CategoriesListRequestModel,
    CategoriesListResponseModel,
    CreateCategoryRequestModel,
    ChangeCategoryNameRequestModel,
    ChangeCategoryStatusRequestModel,
    CreateCategoryResponseModel,
    ChangeCategoryNameResponseModel,
    ChangeCategoryStatusResponseModel,
    DeleteCategoriesListRequestModel,
    GetCategoryResponseModel,
    GetCategoryWithCriterionsResponseModel,
    CriterionsListByCategoryIdResponseModel,
    ChangeCriterionStatusRequestModel,
    ChangeCriterionStatusResponseModel,
    DeleteCriterionsListRequestModel,
    CreateCriterionRequestModel,
    CreateCriterionResponseModel,
    EditCriterionRequestModel,
    EditCriterionResponseModel,
    GetCriterionResponseModel,
    CriterionsListRequestModel,
    CriterionsListResponseModel,
    CategoriesFullListResponseModel,
    TransferCompanyOwnershipRequestModel,
    SubscriptionModel,
    SubscriptionUpdateModel,
    SubscriptionPlanModel,
    ChangeEmployeePasswordRequestModel
} from '../types'
import {BaseClient} from './BaseClient'

export class WebClient extends BaseClient {

    private static instance: WebClient
	
    
    private readonly baseUrl = `${process.env.VUE_APP_BASE_URL}`

    private readonly url = `${this.baseUrl}/system`

    private readonly token?: string

    constructor(token?: string) {
        super()

        if(token) {
            this.token = token
        }
    }
    
    public static getInstance (token?: string): WebClient {
        if (!WebClient.instance) {
            WebClient.instance = new WebClient(token);
        }

        return WebClient.instance
    }

    public static createInstance (token?: string) {
        WebClient.instance = new WebClient(token);
    }

    public readonly loginWithPassword = (model: LoginWithPasswordRequestModel): Promise<LoginWithPasswordResponseModel> => fetch(`${this.url}/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(model)
        })
            .then(response => this.parseResponse(response))            

    public readonly getCompaniesList = (model: CompaniesListRequestModel): Promise<CompaniesListResponseModel> => fetch(`${this.url}/companies/list`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.token}`
        },
        body: JSON.stringify(model)
    })
        .then(response => this.parseResponse(response))   

    public readonly deleteCompaniesList = (model: DeleteCompaniesListRequestModel): Promise<BaseResponseModel> => fetch(`${this.url}/companies/remove`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.token}`
        },
        body: JSON.stringify(model)
    })
        .then(response => this.parseResponse(response))

    public readonly createCompany = (model: CreateCompanyRequestModel): Promise<CreateCompanyResponseModel> => fetch(`${this.url}/companies/create`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.token}`
            },
            body: JSON.stringify(model)
        })
            .then(response => this.parseResponse(response))       
    
    public readonly getCompany = (id: number): Promise<GetCompanyResponseModel> => fetch(`${this.url}/companies/${id}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${this.token}`
            }
        })
            .then(response => this.parseResponse(response))      

    public readonly changeCompanyStatus = (id: number, model: ChangeCompanyStatusRequestModel): Promise<ChangeCompanyStatusResponseModel> => fetch(`${this.url}/companies/${id}/set-status`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.token}`
        },
        body: JSON.stringify(model)
    })
        .then(response => this.parseResponse(response))         
        
    public readonly changeCompanyName = (id: number, model: ChangeCompanyNameRequestModel): Promise<ChangeCompanyNameResponseModel> => fetch(`${this.url}/companies/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.token}`
        },
        body: JSON.stringify(model)
    })
        .then(response => this.parseResponse(response))

    public readonly getCompanyWithUsers= (id: number): Promise<GetCompanyWithUsersResponseModel> => fetch(`${this.url}/companies/${id}/users`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${this.token}`
        }
    })
        .then(response => this.parseResponse(response)) 

    public readonly getCompanySubscription = async (companyId: number): Promise<SubscriptionModel> => fetch(`${this.url}/companies/${companyId}/subscription`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${this.token}`
        }
    })
        .then(response => this.parseResponse(response)) 
        
    public readonly updateCompanySubscription = async (companyId: number, model: SubscriptionUpdateModel): Promise<SubscriptionModel> => fetch(`${this.url}/companies/${companyId}/update-subscription`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.token}`
        },
        body: JSON.stringify(model)
    })
        .then(response => this.parseResponse(response))     

    public readonly getPlansList = async (): Promise<SubscriptionPlanModel []> => fetch(`${this.baseUrl}/plans`, {
        method: 'GET'
    })
        .then(response => this.parseResponse(response))    

    public readonly createEmployee = (companyId: number, model: CreateEmployeeRequestModel): Promise<CreateEmployeeResponseModel | any> => fetch(`${this.url}/companies/${companyId}/users/create`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.token}`,
        },
        body: JSON.stringify(model)
    })
        .then(response => {
            if (response.ok) {
                return response.json()
            }
            else {            
                if(response.status == 401) {
                    const storage = new Storage()
                    storage.clear()     
                    window.location.href = '/'
                }
                else if (response.status == 403){
                    throw new Error('Allowed users limit is reached')
                }
            }
        })


    public readonly deleteEmployeesList = (model: DeleteEmployeesListRequestModel): Promise<BaseResponseModel> => fetch(`${this.url}/users/remove`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.token}`
            },
            body: JSON.stringify(model)
        })
            .then(response => this.parseResponse(response)) 
            
            
    public readonly getEmployee = (id: number): Promise<GetCompanyEmployeeResponseModel> => fetch(`${this.url}/users/${id}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${this.token}`
            }
        })
            .then(response => this.parseResponse(response)) 
                
    public readonly editEmployee = (id: number, model: EditEmployeeRequestModel): Promise<EditEmployeeResponseModel> => fetch(`${this.url}/users/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.token}`
            },
            body: JSON.stringify(model)
        })
            .then(response => this.parseResponse(response))              

    public readonly changeEmployeeStatus = (id: number, model: ChangeEmployeeStatusRequestModel): Promise<ChangeEmployeeStatusResponseModel> => fetch(`${this.url}/users/${id}/set-status`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.token}`
            },
            body: JSON.stringify(model)
        })
            .then(response => this.parseResponse(response))      

    public readonly changeEmployeePassword = (companyId: number, userId: number, model: ChangeEmployeePasswordRequestModel): Promise<BaseResponseModel> => fetch(`${this.url}/companies/${companyId}/users/${userId}/change-password`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.token}`
        },
        body: JSON.stringify(model)
    })
        .then(response => this.parseResponse(response))

    public readonly transferCompanyOwnership = (id: number, model: TransferCompanyOwnershipRequestModel): Promise<BaseResponseModel> => fetch(`${this.url}/companies/${id}/transfer-ownership`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.token}`
        },
        body: JSON.stringify(model)
    })
        .then(response => this.parseResponse(response))          

 
    public readonly getCompanyEmployeesList = (id: number): Promise<CompanyEmployeesListResponseModel> => fetch(`${this.url}/companies/${id}/users-only`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${this.token}`
        }
    })
        .then(response => this.parseResponse(response))     
        
    public readonly getCategoriesList = (model: CategoriesListRequestModel): Promise<CategoriesListResponseModel> => fetch(`${this.url}/criterions/categories/list`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.token}`
        },
        body: JSON.stringify(model)
    })
        .then(response => this.parseResponse(response))       

    public readonly getCategoriesFullList = async (): Promise<CategoriesFullListResponseModel> => fetch(`${this.url}/criterions/categories`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${this.token}`
        }
    })
        .then(response => this.parseResponse(response)) 
        
    public readonly deleteCategoriesList = (model: DeleteCategoriesListRequestModel): Promise<BaseResponseModel> => fetch(`${this.url}/criterions/categories/remove`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.token}`
        },
        body: JSON.stringify(model)
    })
        .then(response => this.parseResponse(response))

    public readonly createCategory = (model: CreateCategoryRequestModel): Promise<CreateCategoryResponseModel> => fetch(`${this.url}/criterions/categories/create`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.token}`
            },
            body: JSON.stringify(model)
        })
            .then(response => this.parseResponse(response))       
    
    public readonly getCategory = (id: number): Promise<GetCategoryResponseModel> => fetch(`${this.url}/criterions/categories/${id}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${this.token}`
            }
        })
            .then(response => this.parseResponse(response))      

    public readonly changeCategoryStatus = (id: number, model: ChangeCategoryStatusRequestModel): Promise<ChangeCategoryStatusResponseModel> => fetch(`${this.url}/criterions/categories/${id}/set-status`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.token}`
        },
        body: JSON.stringify(model)
    })
        .then(response => this.parseResponse(response))      
        
    public readonly changeCategoryName = (id: number, model: ChangeCategoryNameRequestModel): Promise<ChangeCategoryNameResponseModel> => fetch(`${this.url}/criterions/categories/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.token}`
        },
        body: JSON.stringify(model)
    })
        .then(response => this.parseResponse(response))    

    public readonly getCategoryWithCriterions = (id: number): Promise<GetCategoryWithCriterionsResponseModel> => fetch(`${this.url}/criterions/categories/${id}/criterions`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${this.token}`
        }
    })
        .then(response => this.parseResponse(response))     

    public readonly getCriterionsListByCategoryId = (id: number): Promise<CriterionsListByCategoryIdResponseModel> => fetch(`${this.url}/criterions/categories/${id}/criterions-only`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${this.token}`
        }
    })
        .then(response => this.parseResponse(response))       

    public readonly changeCriterionStatus = async (id: number, model: ChangeCriterionStatusRequestModel): Promise<ChangeCriterionStatusResponseModel> => fetch(`${this.url}/criterions/${id}/set-status`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${this.token}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(model)
    })
        .then(response => this.parseResponse(response))      
        
    public readonly deleteCriterionsList = async (model: DeleteCriterionsListRequestModel): Promise<BaseResponseModel> => fetch(`${this.url}/criterions/remove`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.token}`
        },
        body: JSON.stringify(model)
    })
        .then(response => this.parseResponse(response))    

    public readonly createCriterion = async (model: CreateCriterionRequestModel): Promise<CreateCriterionResponseModel> => fetch(`${this.url}/criterions/create`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.token}`
        },
        body: JSON.stringify(model)
    })
        .then(response => this.parseResponse(response))    

    public readonly editCriterion = async (id: number, model: EditCriterionRequestModel): Promise<EditCriterionResponseModel> => fetch(`${this.url}/criterions/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.token}`
        },
        body: JSON.stringify(model)
    })
        .then(response => this.parseResponse(response))      

    public readonly getCriterion = (id: number): Promise<GetCriterionResponseModel> => fetch(`${this.url}/criterions/${id}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${this.token}`
        }
    })
        .then(response => this.parseResponse(response))     

    public readonly getCriterionsList = async (model: CriterionsListRequestModel): Promise<CriterionsListResponseModel> => fetch(`${this.url}/criterions/list`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.token}`
        },
        body: JSON.stringify(model)
    })
        .then(response => this.parseResponse(response))        
}